import React from 'react';
//internal and external components/containers import
import SearchFilterContainer from '../SearchFilterContainer';
import JLHomeContainers from '../JLHomeContainers';
import { Box } from '@mui/material';

const JLHome = () => {
    return(
        <React.Fragment>
            <Box className={'contentSpacing'}>
                <SearchFilterContainer parent={'home'} />
                <JLHomeContainers />
            </Box>
        </React.Fragment>
    )
}

export default JLHome;